{
  "<0>{{selectedCount}}</0> {t('of')} <4>{{totalCount}}</4> {{contactsText}} {t('selected')}": "<0>{{selectedCount}}</0> {t('of')} <4>{{totalCount}}</4> {{contactsText}} {t('selected')}",
  "A summary of the practice's text message outreach for filling last-minute appointments. It includes message details, patient responses, appointment outcomes, and key metrics, enabling assessment of the campaign's effectiveness and patient engagement.": "A summary of the practice's text message outreach for filling last-minute appointments. It includes message details, patient responses, appointment outcomes, and key metrics, enabling assessment of the campaign's effectiveness and patient engagement.",
  "Add Note": "Add Note",
  "Add Slot": "Add Slot",
  "Add to List": "Add to List",
  "Add to list": "Add to list",
  "All Locations": "All Locations",
  "All locations": "All locations",
  "Appointment Booked!": "Appointment Booked!",
  "Appointment Details": "Appointment Details",
  "Appointment Slot": "Appointment Slot",
  "Appointment Type": "Appointment Type",
  "Appointment on {{date}}": "Appointment on {{date}}",
  "Are you sure you want to decline this appointment and stay on the waitlist?": "Are you sure you want to decline this appointment and stay on the waitlist?",
  "Awaiting Response": "Awaiting Response",
  "Back": "Back",
  "Book Appointment": "Book Appointment",
  "Calendar": "Calendar",
  "Cancel": "Cancel",
  "Check it Out": "Check it Out",
  "Checking availability for the selected provider, date and time...": "Checking availability for the selected provider, date and time...",
  "Checking availability. Please wait a moment and try again.": "Checking availability. Please wait a moment and try again.",
  "Clear All": "Clear All",
  "Click a tag below to add it to your message": "Click a tag below to add it to your message",
  "Click to Call": "Click to Call",
  "Close": "Close",
  "Compose Message": "Compose Message",
  "Date": "Date",
  "Decline": "Decline",
  "Decline & Stay on Waitlist": "Decline & Stay on Waitlist",
  "Decline Appointment": "Decline Appointment",
  "Deselect All": "Deselect All",
  "Direct Booked": "Direct Booked",
  "Direct Scheduling": "Direct Scheduling",
  "Dismiss": "Dismiss",
  "Done": "Done",
  "Easily fill last-minute cancellations or openings in your schedule by messaging your customers who need to get in for an appointment as soon as possible.": "Easily fill last-minute cancellations or openings in your schedule by messaging your customers who need to get in for an appointment as soon as possible.",
  "Edit Note": "Edit Note",
  "Enable Direct Scheduling": "Enable Direct Scheduling",
  "Error Adding Custom Contact": "Error Adding Custom Contact",
  "Error Adding Waitlist Recipient": "Error Adding Waitlist Recipient",
  "Error Deleting Waitlist Recipient": "Error Deleting Waitlist Recipient",
  "Error Updating Waitlist Recipient": "Error Updating Waitlist Recipient",
  "Failed to send Waitlist message": "Failed to send Waitlist message",
  "Hello [First Name], this is [Practice Name]. We have a last minute opening for [Date Time]. \nClick this link to book now [Booking Link]": "Hello [First Name], this is [Practice Name]. We have a last minute opening for [Date Time]. \nClick this link to book now [Booking Link]",
  "Hello, {{FIRST_NAME}}, this is {{PRACTICE_NAME}}. We have last minute opening for {{DATE_TIME}}\n\nReply to schedule an appointment.": "Hello, {{FIRST_NAME}}, this is {{PRACTICE_NAME}}. We have last minute opening for {{DATE_TIME}}\n\nReply to schedule an appointment.",
  "If you'd like to be removed from the waitlist, just send us a text.": "If you'd like to be removed from the waitlist, just send us a text.",
  "Location": "Location",
  "Locations": "Locations",
  "Message Date & Time": "Message Date & Time",
  "Message Date and Time": "Message Date and Time",
  "Message Preview": "Message Preview",
  "Message Recipients": "Message Recipients",
  "Messaging is disabled for this location": "Messaging is disabled for this location",
  "Minutes": "Minutes",
  "Name": "Name",
  "New Name!": "New Name!",
  "Next": "Next",
  "No Waitlist recipients found": "No Waitlist recipients found",
  "No availability found for the selected provider, date and time. Please select a different time slot or provider.": "No availability found for the selected provider, date and time. Please select a different time slot or provider.",
  "No availability found for the selected time slot. Please choose a different time or provider.": "No availability found for the selected time slot. Please choose a different time or provider.",
  "No notes": "No notes",
  "Open Waitlist": "Open Waitlist",
  "Opted Out": "Opted Out",
  "Provider": "Provider",
  "Quickfill is now Waitlist — and it just got better with direct booking!": "Quickfill is now Waitlist — and it just got better with direct booking!",
  "Recipient": "Recipient",
  "Refresh Data": "Refresh Data",
  "Remove": "Remove",
  "Remove From List": "Remove From List",
  "Reservation of this appointment is on a first come first served basis, and the details can not be changed.": "Reservation of this appointment is on a first come first served basis, and the details can not be changed.",
  "Save": "Save",
  "Search by name": "Search by name",
  "Select": "Select",
  "Select All": "Select All",
  "Select a Waitlist Template": "Select a Waitlist Template",
  "Selected time has already passed": "Selected time has already passed",
  "Send Message": "Send Message",
  "Send waitlisted customers a direct booking link to fill last-minute cancellations fast": "Send waitlisted customers a direct booking link to fill last-minute cancellations fast",
  "Sending to": "Sending to",
  "Someone else has already taken this appointment time, but you're still on the waitlist and will receive notifications for future openings.": "Someone else has already taken this appointment time, but you're still on the waitlist and will receive notifications for future openings.",
  "Start building your Waitlist for unexpected schedule gaps.": "Start building your Waitlist for unexpected schedule gaps.",
  "Status": "Status",
  "Text Response": "Text Response",
  "That appointment is no longer available": "That appointment is no longer available",
  "The selected time slots are available for booking.": "The selected time slots are available for booking.",
  "There was an error booking your appointment. Please try again.": "There was an error booking your appointment. Please try again.",
  "There was an error checking availability for the selected provider, date and time. Please try again later.": "There was an error checking availability for the selected provider, date and time. Please try again later.",
  "There was an error processing your response. Please try again.": "There was an error processing your response. Please try again.",
  "This contact does not belong to any location that uses Waitlist.": "This contact does not belong to any location that uses Waitlist.",
  "This location doesn't have Waitlist.": "This location doesn't have Waitlist.",
  "Time": "Time",
  "Undelivered": "Undelivered",
  "Waitlist": "Waitlist",
  "Waitlist History": "Waitlist History",
  "Waitlist Recipient Added": "Waitlist Recipient Added",
  "Waitlist Recipient Deleted": "Waitlist Recipient Deleted",
  "Waitlist Recipient Updated": "Waitlist Recipient Updated",
  "Waitlist Recipient updated successfully": "Waitlist Recipient updated successfully",
  "Waitlist is not enabled for any of your selected locations.": "Waitlist is not enabled for any of your selected locations.",
  "Waitlist message sent successfully": "Waitlist message sent successfully",
  "When Direct Scheduling is enabled, the {{contact}} will receive a link where they can automatically book the appointment.": "When Direct Scheduling is enabled, the {{contact}} will receive a link where they can automatically book the appointment.",
  "You Are Still on the Waitlist!": "You Are Still on the Waitlist!",
  "You do not have permission to send messages": "You do not have permission to send messages",
  "You have declined the appointment but remain on the waitlist.": "You have declined the appointment but remain on the waitlist.",
  "You have declined this appointment time, but you will remain on the waitlist and be notified when future appointment times become available.": "You have declined this appointment time, but you will remain on the waitlist and be notified when future appointment times become available.",
  "Your appointment has been successfully booked!": "Your appointment has been successfully booked!",
  "Your appointment is confirmed. You will receive a text message with confirmation details shortly and your name has now been removed from the waitlist.": "Your appointment is confirmed. You will receive a text message with confirmation details shortly and your name has now been removed from the waitlist.",
  "company logo": "company logo",
  "of": "of",
  "selected": "selected",
  "{{personName}} is already on the waitlist.": "{{personName}} is already on the waitlist."
}
